(() => {
  'use strict';
  const host = document.querySelector('[data-mayhem-contact-context]');
  if (!host) return;
  const labels = JSON.parse(document.querySelector('[data-mayhem-contact-labels]').textContent);
  const text = host.querySelector('textarea');
  const status = host.querySelector('[data-contact-status]');
  const section=host.closest('.mayhem-support-email');
  const container = section.querySelector('[data-mayhem-contact-hubspot]');
  let hubspotForm = null;
  const formRoots = () => hubspotForm?.isConnected ? [hubspotForm] : [];
  let formStarted = false, submitted = false;
  const renderForm = () => {
    if (formStarted || !container || !section.getClientRects().length || !window.hbspt?.forms) return;
    formStarted = true;
    window.hbspt.forms.create({
      portalId: '4359305',
      formId: '1b5ec34e-8ffd-4641-9172-ad552a8e8388',
      target: '#' + container.id,
      onFormReady: form => {
        hubspotForm = form?.nodeType === 1 ? form : form?.[0];
        container.querySelectorAll('iframe').forEach(frame => { frame.title = section.getAttribute('aria-label'); });
        prefill();
      },
      onFormSubmitted: () => {
        if (submitted) return;
        submitted = true;
        window.MayhemAnalytics?.track('generate_lead', { source: section.closest('[data-mhs-contact-panel]') ? 'hubspot_support' : 'hubspot_contact' });
        try { sessionStorage.removeItem(key); } catch {}
      }
    });
  };
  let hubspotScript = document.querySelector('[data-mayhem-hubspot-script]');
  if (!window.hbspt && !hubspotScript) {
    hubspotScript = document.createElement('script');
    hubspotScript.src = 'https://js.hsforms.net/forms/v2.js';
    hubspotScript.defer = true;
    hubspotScript.dataset.mayhemHubspotScript = '';
    document.head.append(hubspotScript);
  }
  hubspotScript?.addEventListener('load', renderForm, { once: true });
  const filled = new Map();
  const watched = new WeakSet();
  let context = null, timer, scanTimer;
  const key = 'mayhem:contact-context:v1';
  const clean = value => typeof value === 'string' ? value.slice(0, 12000) : '';
  const write = (field, value) => {
    const view = field.ownerDocument.defaultView;
    const prototype = field.tagName === 'TEXTAREA' ? view.HTMLTextAreaElement.prototype : view.HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(prototype, 'value').set.call(field, value);
    field.dispatchEvent(new view.Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new view.Event('change', { bubbles: true, composed: true }));
  };
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(prefill, 100); });
  const scan = node => {
    if (node.shadowRoot) scan(node.shadowRoot);
    if (!watched.has(node)) { watched.add(node); observer.observe(node, { childList: true, subtree: true }); }
    for (const field of node.querySelectorAll('input:not([type="file"]):not([type="hidden"]),textarea')) {
      if (field.closest('[data-mayhem-contact-context]') || field.disabled || field.readOnly) continue;
      const name = [field.name, field.id, field.getAttribute('aria-label'), ...Array.from(field.labels || [], label => label.textContent)].join(' ').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
      const value = /vehicle/.test(name) ? context.vehicle : /wheel.*(style|part)|wheelstyleorpartnumber/.test(name) ? context.wheel : /\b(?:message|question|details)\b|how can we help|tell us about/.test(name) ? text.value : '';
      if (!value || (field.value.trim() && field.value !== filled.get(field))) continue;
      if(field.value===value)continue;
      filled.set(field, value); write(field, value);
    }
    for (const element of node.querySelectorAll('*')) if (element.shadowRoot) scan(element.shadowRoot);
  };
  function prefill() {
    if (!context) return;
    for (const root of formRoots()) scan(root);
  }
  const show = value => {
    if (!value || !Number.isFinite(value.created) || Date.now() - value.created > 30 * 60 * 1000 || value.created > Date.now() + 60000) return;
    context = { vehicle: clean(value.vehicle), wheel: clean(value.wheel), question: clean(value.question), message: clean(value.message) };
    text.value = [context.question && `${labels.question}: ${context.question}`, context.message || [context.vehicle && `${labels.vehicle}: ${context.vehicle}`, context.wheel && `${labels.wheel}: ${context.wheel}`].filter(Boolean).join('\n')].filter(Boolean).join('\n\n');
    host.hidden = !text.value;
    const emailLink = document.querySelector('[data-contact-email]');
    if(emailLink)emailLink.href = `mailto:customerservice@mayhemwheels.com?subject=${encodeURIComponent(labels.subject)}&body=${encodeURIComponent(text.value)}`;
    prefill();
    clearInterval(scanTimer);
    let attempts = 0;
    scanTimer = setInterval(() => { prefill(); if (++attempts >= 120) clearInterval(scanTimer); }, 250);
  };
  window.addEventListener('mayhem:contact-context', event => show(event.detail));
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (value && Date.now() - value.created > 30 * 60 * 1000) sessionStorage.removeItem(key);
    if (new URL(location.href).searchParams.get('setup') !== '1') show(value);
  } catch {}
  const pageObserver = new MutationObserver(() => { if (context) prefill(); });
  pageObserver.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  window.addEventListener('message',event=>{
    if(event.origin===location.origin && event.source===parent && event.data?.type==='mayhem:contact-context')show(event.data.context);
  });
  const loading=document.querySelector('[data-contact-loading]');
  const fallback=document.querySelector('[data-contact-fallback]');
  const retry=document.createElement('button');
  retry.type='button';retry.textContent='Open contact form';retry.hidden=true;
  retry.className='mayhem-contact-retry';
  fallback?.before(retry);
  retry.addEventListener('click',()=>{
    // Never replace a form that has mounted or contains customer input.
    if([...formRoots()].some(hasForm))return;
    const url=new URL(location.href);
    url.pathname=(window.Shopify?.routes?.root || '/')+'pages/contact';
    url.search='';url.hash='';
    const queryPreview=new URL(location.href).searchParams.get('preview_theme_id');
    // Shopify may remove the query parameter from a draft preview URL while
    // keeping the preview bar. Preserve the actual current unpublished theme
    // when recovering to the full contact page, never accidentally falling
    // back to the store's published theme.
    const themeId=String(window.Shopify?.theme?.id||'');
    const isThemePreview=!!document.getElementById('PBarNextFrameWrapper');
    const preview=queryPreview||(isThemePreview&&/^[0-9]{8,20}$/.test(themeId)?themeId:'');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    location.assign(url.href);
  });
  let visibleAttempts=0, failureTracked=false;
  const hasForm = node => !!node.querySelector('input[type="email"]');
  const readiness=setInterval(()=>{
    // A hidden popup is not a failed customer journey. Keep watching after fallback
    // so an app form that mounts late can replace it without losing the draft.
    if(document.hidden || (section && !section.getClientRects().length))return;
    renderForm();
    const ready=submitted || [...formRoots()].some(hasForm);
    if(ready){
      retry.hidden=true;
      if(loading)loading.hidden=true;
      if(fallback)fallback.hidden=true;
      prefill();
      clearInterval(readiness);
    }else if(++visibleAttempts>=24){
      retry.hidden=false;
      if(loading)loading.hidden=true;
      if(fallback)fallback.hidden=false;
      if(!failureTracked){
        failureTracked=true;
        window.MayhemJourney?.track('support_failure',{surface:'contact',state:'unavailable'});
      }
    }
  },500);
  window.addEventListener('pagehide', () => {
    clearInterval(readiness); clearInterval(scanTimer); clearTimeout(timer);
    observer.disconnect(); pageObserver.disconnect();
  }, { once: true });
})();

